import * as React from 'react';

import Slider from '../slider/slider';
import withSlider from '../../hocs/with-slider/with-slider';

import MockData from '../../mock/mock-data';
import MockSlide from '../../mock/slide/slide';

interface State {
  visualSlidesCount: number;
  isFlipping: boolean;
  sliderHeight: number;
}

const WithSlider = withSlider(Slider);

class App extends React.PureComponent<{}, State> {

  constructor(props) {
    super(props);

    this.state = {
      visualSlidesCount: 3,
      isFlipping: true,
      sliderHeight: 280,
    };

    this._windowResizeHandler = this._windowResizeHandler.bind(this);
  }

  render() {

    return (
      <WithSlider
        visualSlidesCount={this.state.visualSlidesCount}
        isFlipping={this.state.isFlipping}
        sliderHeight={this.state.sliderHeight}
      >
        {MockData.map((it) => <MockSlide description={it} key={it.id}/>)}
      </WithSlider>
    );
  }

  private _windowResizeHandler(): void {
    if (window.matchMedia(`(min-width: 1140px)`).matches) {
      this.setState({
        isFlipping: true,
        sliderHeight: 280,
      });
    } else {
      this.setState({
        isFlipping: false,
        sliderHeight: 250,
      });
    }
    if (window.matchMedia(`(min-width: 600px)`).matches) {
      this.setState({
        visualSlidesCount: 3,
      });
    } else {
      this.setState({
        visualSlidesCount: 1,
      });
    }
  }

  componentDidMount() {
    this._windowResizeHandler();
    window.addEventListener(`resize`, this._windowResizeHandler);
  }

  componentWillUnmount() {
    window.removeEventListener(`resize`, this._windowResizeHandler);
  }
}

export default App;
